export * from './NewsBlock';